import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';

@Component({
  selector: 'app-list-packages',
  templateUrl: './list-packages.component.html',
  styleUrls: ['./list-packages.component.scss'],
})
export class ListPackagesComponent implements OnInit {
  @ViewChild('modalPackage', { static: false }) modalPackage!: TemplateRef<any>;
  modalPackageClose: any;
  filterText: string = '';
  packages: any[] = [];
  filterPackages: any = [];
  breadcrumbs: any;
  rolename: any = '';
  rolekey: any = '';
  idDeleted: number = 0;
  packageNameDeleted: string = '';
  flagDeleted: boolean = false;
  message: string = '';
  offices: any = [];
  roleofficeid: number = 0;
  currentOfficeId: number = 0;
  confirmDelete: boolean = false;
  // cambios paginacion
  totalPages: number = 0; 
  limit: number = 25;
  totalItems: number = 0;
  page: number = 1;
  nextLabel = 'Siguiente';
previousLabel = 'Anterior';

  constructor(
    private api: ApiService,
    private modal: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private printService: PrintService
  ) {}

  ngOnInit(): void {
    this.breadcrumbs = [
      { name: 'Agenda', path: '/dashboard/new-calendar', link: true },
      { name: 'Lista de paquetes', link: false },
    ];
    const savedPage = this.route.snapshot.queryParamMap.get('page');
    this.page = savedPage ? +savedPage : 1;

    this.loadPackages(this.page); 
    this.roleInfo();
    this.getOffices();
  }

  reloadInfo() {
    this.loadPackages(this.page); 
    this.roleInfo();
    this.getOffices();
  }

  roleInfo() {
    this.api.get('employees/roles').subscribe({
      next: (roles) => {
        this.rolename = roles.user.role;
        this.rolekey = roles.user.key.toLowerCase();
        this.roleofficeid = roles.user.office.id;
        this.currentOfficeId = this.roleofficeid;
      },
      error: (err) => {},
    });
  }

loadPackages(page: number = 1) {
  this.page = page;
  this.api.get(`packages/${this.currentOfficeId}?page=${page}&limit=${this.limit}`)
    .subscribe((res: any) => {
      this.packages = res.packages;
      this.filterPackages = this.packages;
      this.totalItems = res.total;
      this.totalPages = Math.ceil(this.totalItems / this.limit);
    });
}
  
  deletePackages(id: number): void {
    this.api.delete('packages/delete', Number(id)).subscribe({
      next: (packages) => {
        this.message = packages.message;
        const id = packages.packages.id;
        this.flagDeleted = true;

        this.filterPackages = this.filterPackages.filter(
          (packageData: any) => Number(packageData.id) !== Number(id)
        );
        this.modalPackageClose.close();
      },
      error: (err) => {},
    });

    setTimeout(() => {
      this.flagDeleted = false;
      this.message = '';
    }, 4000);
  }

  confirmDeletePackages(flag: boolean) {
    if (flag === false) {
      this.close();
    }

    this.confirmDelete = flag;
  }

  getOffices() {
    this.api.get('offices').subscribe({
      next: (offices) => {
        this.offices = offices.offices;
      },
      error: (err) => {},
    });
  }

  setCurrentOffice(evt: any) {
    this.api.get(`packages/${evt.target.value}`).subscribe({
      next: (packages) => {
        this.packages = packages.packages;
        this.filterPackages = this.packages;
      },
      error: (err) => {},
    });
  }

  clearSearch() {
    this.filterText = '';
    this.currentOfficeId = this.roleofficeid;
    this.loadPackages();
  }

  openDeleteMessage(id: number, packagename: string): void {
    this.idDeleted = id;
    this.packageNameDeleted = packagename;

    this.modalPackageClose = this.modal.open(this.modalPackage, { size: 'md' });
  }

  close(): void {
    this.modalPackageClose.close();
  }

  matches(listData: any, term: string) {
    return (
      listData.client.name.toLowerCase().includes(term.toLowerCase()) ||
      listData.client.office.toLowerCase().includes(term.toLowerCase()) ||
      listData.price.includes(term) ||
      listData.duration.includes(term) ||
      listData.date_purchased.includes(term)
    );
  }

  filterRecords() {
    const filterData = this.packages.filter((data: any) => {
      return this.matches(data, this.filterText);
    });

    this.filterPackages = filterData;
    this.page = 1;
  }

  onPageChange(page: number) {
 this.page = page;
  this.loadPackages(page);

  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { page: this.page },
    queryParamsHandling: 'merge'
  });
  }

  printTicketAgain(printTicket: any): void {
    if (printTicket.state_code == 'Bc') {
      this.api.onPrintRecipientPeninsula(printTicket);
    } else {
      this.api.onPrintRecipient(printTicket);
    }
  }
  //Metodo para visibilizar un máximo de 4 páginas en la paginación
getVisiblePages(): number[] {
  const max = 4;

  let start = this.page;
  let end = this.page + max - 1;

  if (end > this.totalPages) {
    end = this.totalPages;
    start = end - max + 1;
  }

  if (start < 1) start = 1;

  const pages = [];
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
}
}
